"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
var constants_1 = require("../../constants");
var server_1 = require("../../helpers/server");
var model_1 = require("../../model");
var PortalPage_1 = require("../_shared/components/PortalPage");
var layout_1 = require("../_shared/components/layout");
var ProposalPanel_1 = require("../userHoursDetail/proposal/ProposalPanel");
require("./GpsProposalPage.scss");
/**
 * Standalone GPS proposal page.
 *
 * Reachable two ways, which is why the worker and date are in the URL rather
 * than in component state alone: from a worker's day (pre-filled, opens in its
 * own tab) and from the side menu (empty, pick your own). Changing either
 * selector rewrites the URL, so any view of this page can be shared as a link.
 */
var GpsProposalPage = /** @class */ (function (_super) {
    __extends(GpsProposalPage, _super);
    function GpsProposalPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            workers: [],
            loadingWorkers: true,
            userId: _this.props.match.params.id || '',
            date: _this.props.match.params.day || moment().tz(constants_1.DEFAULT_TIMEZONE).format('YYYY-MM-DD'),
        };
        return _this;
    }
    GpsProposalPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, workers, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canPreview()) {
                            this.setState({ loadingWorkers: false });
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.get)(constants_1.API.USERS_URI, { type: model_1.UserType.APP, limit: 500 })];
                    case 2:
                        res = _a.sent();
                        workers = (res.results || [])
                            .filter(function (u) { return u.isActive !== false; })
                            .sort(function (a, b) { return (0, model_1.getUserFullName)(a).localeCompare((0, model_1.getUserFullName)(b)); });
                        this.setState({ workers: workers, loadingWorkers: false });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setState({ loadingWorkers: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GpsProposalPage.prototype.canPreview = function () {
        var identity = this.props.identity;
        if (!identity) {
            return false;
        }
        if (identity.role === model_1.UserRoles.ADMIN || identity.role === model_1.UserRoles.SUPERADMIN) {
            return true;
        }
        return !!(identity.settings && identity.settings.canPreviewGpsProposal);
    };
    /** Keep the URL in step with the selectors, so the view stays linkable. */
    GpsProposalPage.prototype.select = function (userId, date) {
        this.setState({ userId: userId, date: date });
        var path = userId && date ? "/gps-proposal/".concat(userId, "/").concat(date) : '/gps-proposal';
        this.props.history.replace(path);
    };
    GpsProposalPage.prototype.renderPicker = function () {
        var _this = this;
        var _a = this.state, workers = _a.workers, loadingWorkers = _a.loadingWorkers, userId = _a.userId, date = _a.date;
        return (React.createElement("div", { className: "gps-proposal-picker" },
            React.createElement("label", { htmlFor: "gp-worker" }, "Medewerker"),
            React.createElement("select", { id: "gp-worker", value: userId, disabled: loadingWorkers, onChange: function (e) { return _this.select(e.target.value, date); } },
                React.createElement("option", { value: "" }, loadingWorkers ? 'Laden…' : 'Kies een medewerker…'),
                workers.map(function (w) { return (React.createElement("option", { key: w._id, value: w._id },
                    (0, model_1.getUserFullName)(w),
                    w.role ? " \u2014 ".concat(w.role) : '')); })),
            React.createElement("label", { htmlFor: "gp-date" }, "Datum"),
            React.createElement("input", { id: "gp-date", type: "date", value: date, max: moment().tz(constants_1.DEFAULT_TIMEZONE).format('YYYY-MM-DD'), onChange: function (e) { return _this.select(userId, e.target.value); } })));
    };
    GpsProposalPage.prototype.render = function () {
        var _a = this.state, userId = _a.userId, date = _a.date;
        return (React.createElement(PortalPage_1.default, { page: model_1.Permission.PAGE_HOURS, id: "gps-proposal-page", isLoading: false, subPages: ['GPS-voorstel'] },
            React.createElement(layout_1.Wrapper, { padding: "16px" }, !this.canPreview()
                ? React.createElement("p", null, "Je hebt geen toegang tot de GPS-voorstelweergave.")
                : React.createElement(React.Fragment, null,
                    this.renderPicker(),
                    userId && date
                        ? React.createElement(ProposalPanel_1.default, { key: "".concat(userId, "-").concat(date), userId: userId, date: date })
                        : React.createElement("p", { className: "gps-proposal-empty" }, "Kies een medewerker en een datum om het voorstel op te bouwen.")))));
    };
    return GpsProposalPage;
}(React.Component));
var mapStateToProps = function (_) { return ({
    identity: _.reducer.authentication.user,
}); };
exports.default = (0, react_redux_1.connect)(mapStateToProps)(GpsProposalPage);
